(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["luxury-cart-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const rootSelector = '[data-srcart-root]';

    const enhanceCart = (root) => {
      if (!root) return;
      root.classList.add('is-enhanced');
      root.querySelectorAll('[data-srcart-quantity]').forEach((input) => {
        const row = input.closest('[data-srcart-item]');
        const decrease = row?.querySelector('[data-srcart-action="decrease"]');
        if (decrease) decrease.disabled = Number(input.value) <= 1;
      });
    };

    const setBusy = (root, busy) => {
      root.classList.toggle('is-loading', busy);
      root.setAttribute('aria-busy', String(busy));
      root.querySelectorAll('button, input').forEach((control) => {
        control.disabled = busy;
      });
      root.querySelectorAll('[data-srcart-remove]').forEach((link) => {
        link.setAttribute('aria-disabled', String(busy));
      });
    };

    const updateHeaderCount = (itemCount) => {
      const cartButton = document.querySelector('.srs-header__cart');
      if (!cartButton) return;

      let count = cartButton.querySelector('.srs-header__cart-count');
      if (itemCount > 0 && !count) {
        count = document.createElement('span');
        count.className = 'srs-header__cart-count';
        count.setAttribute('aria-hidden', 'true');
        cartButton.appendChild(count);
      }

      if (count) {
        if (itemCount > 0) {
          count.textContent = String(itemCount);
        } else {
          count.remove();
        }
      }

      const currentLabel = cartButton.getAttribute('aria-label') || 'Cart';
      const baseLabel = currentLabel.split(':')[0];
      cartButton.setAttribute('aria-label', baseLabel + ': ' + itemCount);
    };

    const replaceCart = (root, html, itemCount, focus) => {
      const sectionId = root.dataset.sectionId;
      const currentWrapper = document.getElementById('shopify-section-' + sectionId);
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const nextWrapper = parsed.getElementById('shopify-section-' + sectionId);

      if (!currentWrapper || !nextWrapper) {
        window.location.reload();
        return;
      }

      currentWrapper.replaceWith(nextWrapper);
      const nextRoot = nextWrapper.querySelector(rootSelector);
      enhanceCart(nextRoot);
      updateHeaderCount(itemCount);

      window.requestAnimationFrame(() => {
        let target;

        if (focus?.mode === 'remove') {
          target =
            nextRoot.querySelector('[data-srcart-items-focus]') ||
            nextRoot.querySelector('[data-srcart-empty-focus]');
        } else if (focus?.line) {
          const row = nextRoot.querySelector('[data-srcart-item][data-line="' + focus.line + '"]');
          if (focus.action === 'quantity') {
            target = row?.querySelector('[data-srcart-quantity]');
          } else {
            target = row?.querySelector('[data-srcart-action="' + focus.action + '"]');
          }
        }

        if (target) target.focus({ preventScroll: true });
      });
    };

    const requestCart = async (root, endpoint, payload, focus) => {
      const sectionId = root.dataset.sectionId;
      const status = root.querySelector('[data-srcart-status]');
      const rootUrl = window.Shopify?.routes?.root || '/';

      if (status) status.textContent = root.dataset.updatingLabel + '…';
      setBusy(root, true);

      try {
        const response = await fetch(rootUrl + endpoint, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({
            ...payload,
            sections: [sectionId],
            sections_url: window.location.pathname
          })
        });

        const result = await response.json().catch(() => ({}));
        if (!response.ok) {
          throw new Error(result.description || root.dataset.cartError);
        }

        const html = result.sections?.[sectionId];
        if (!html) {
          window.location.reload();
          return;
        }

        replaceCart(root, html, result.item_count, focus);
      } catch (error) {
        root.querySelectorAll('[data-srcart-quantity]').forEach((input) => {
          input.value = input.dataset.currentQuantity;
        });
        setBusy(root, false);
        enhanceCart(root);
        if (status) status.textContent = error.message || root.dataset.cartError;
      }
    };

    const changeLine = (row, quantity, action) => {
      const root = row.closest(rootSelector);
      if (!root) return;

      requestCart(
        root,
        'cart/change.js',
        {
          id: row.dataset.lineKey,
          quantity
        },
        {
          line: row.dataset.line,
          action,
          mode: quantity === 0 ? 'remove' : 'change'
        }
      );
    };

    document.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-srcart-remove]');
      if (remove) {
        const row = remove.closest('[data-srcart-item]');
        if (!row) return;
        event.preventDefault();
        changeLine(row, 0, 'remove');
        return;
      }

      const actionButton = event.target.closest('[data-srcart-action]');
      if (!actionButton) return;

      const row = actionButton.closest('[data-srcart-item]');
      const input = row?.querySelector('[data-srcart-quantity]');
      if (!row || !input) return;

      event.preventDefault();
      const current = Math.max(1, Number(input.value) || 1);
      const action = actionButton.dataset.srcartAction;
      const next = action === 'increase' ? current + 1 : Math.max(1, current - 1);

      if (next === current) return;
      input.value = String(next);
      changeLine(row, next, action);
    });

    document.addEventListener('input', (event) => {
      const input = event.target.closest('[data-srcart-quantity]');
      if (!input) return;

      const row = input.closest('[data-srcart-item]');
      const decrease = row?.querySelector('[data-srcart-action="decrease"]');
      if (decrease) decrease.disabled = Number(input.value) <= 1;
    });

    document.addEventListener('change', (event) => {
      const input = event.target.closest('[data-srcart-quantity]');
      if (!input) return;

      const row = input.closest('[data-srcart-item]');
      if (!row) return;

      const quantity = Math.max(1, Math.floor(Number(input.value) || 1));
      input.value = String(quantity);
      if (quantity === Number(input.dataset.currentQuantity)) return;
      changeLine(row, quantity, 'quantity');
    });

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-srcart-form]');
      if (!form || event.submitter?.name === 'checkout') return;

      const root = form.closest(rootSelector);
      if (!root) return;

      event.preventDefault();
      const updates = {};
      form.querySelectorAll('[data-srcart-item]').forEach((row) => {
        const input = row.querySelector('[data-srcart-quantity]');
        updates[row.dataset.lineKey] = Math.max(1, Math.floor(Number(input.value) || 1));
      });

      requestCart(root, 'cart/update.js', { updates }, { action: 'quantity' });
    });

    document.querySelectorAll(rootSelector).forEach(enhanceCart);
    document.addEventListener('shopify:section:load', (event) => {
      enhanceCart(event.target.querySelector(rootSelector));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseFooter = (root) => {
      if (!root || root.dataset.srsFooterReady === 'true') return;
      root.dataset.srsFooterReady = 'true';

      const groups = root.querySelectorAll('[data-srs-footer-group]');
      const desktop = window.matchMedia('(min-width: 750px)');
      const synchroniseGroups = () => {
        groups.forEach((group) => {
          group.open = desktop.matches;
        });
      };

      groups.forEach((group) => {
        const summary = group.querySelector('summary');
        if (!summary) return;
        summary.addEventListener('click', (event) => {
          if (desktop.matches) event.preventDefault();
        });
      });

      synchroniseGroups();
      if (typeof desktop.addEventListener === 'function') {
        desktop.addEventListener('change', synchroniseGroups);
      } else {
        desktop.addListener(synchroniseGroups);
      }
    };

    document.querySelectorAll('.srs-footer').forEach(initialiseFooter);
    document.addEventListener('shopify:section:load', (event) => {
      initialiseFooter(event.target.querySelector('.srs-footer'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseHeader = (root) => {
      if (!root || root.dataset.srsHeaderReady === 'true') return;

      const opener = root.querySelector('[data-srs-drawer-open]');
      const drawer = root.querySelector('[data-srs-drawer]');
      const panel = root.querySelector('[data-srs-drawer-panel]');
      const closers = root.querySelectorAll('[data-srs-drawer-close]');
      if (!opener || !drawer || !panel) return;

      root.dataset.srsHeaderReady = 'true';
      let lastFocused = null;

      const getFocusable = () => Array.from(
        panel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      );

      const closeDrawer = () => {
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        panel.setAttribute('inert', '');
        opener.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('srs-drawer-open');
        if (lastFocused) lastFocused.focus();
      };

      const openDrawer = () => {
        lastFocused = document.activeElement;
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        panel.removeAttribute('inert');
        opener.setAttribute('aria-expanded', 'true');
        document.body.classList.add('srs-drawer-open');
        const focusable = getFocusable();
        if (focusable.length) focusable[0].focus();
      };

      opener.addEventListener('click', openDrawer);
      closers.forEach((closer) => closer.addEventListener('click', closeDrawer));

      drawer.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') {
          closeDrawer();
          return;
        }
        if (event.key !== 'Tab') return;
        const focusable = getFocusable();
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      });

      window.addEventListener('resize', () => {
        if (window.innerWidth >= 990 && drawer.classList.contains('is-open')) closeDrawer();
      });
    };

    document.querySelectorAll('[data-srs-header]').forEach(initialiseHeader);
    document.addEventListener('shopify:section:load', (event) => {
      initialiseHeader(event.target.querySelector('[data-srs-header]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["luxury-product-page"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialiseProduct = (root) => {
      if (!root || root.dataset.srpReady === 'true') return;
      root.dataset.srpReady = 'true';

      const quantityInput = root.querySelector('input[name="quantity"]');
      root.querySelector('[data-srp-quantity-minus]')?.addEventListener('click', () => {
        if (!quantityInput) return;
        quantityInput.value = Math.max(1, Number(quantityInput.value || 1) - 1);
      });
      root.querySelector('[data-srp-quantity-plus]')?.addEventListener('click', () => {
        if (!quantityInput) return;
        quantityInput.value = Math.max(1, Number(quantityInput.value || 1) + 1);
      });

      const form = root.querySelector('.srp__form');
      const button = root.querySelector('[data-srp-add-button]');
      const buttonLabel = root.querySelector('[data-srp-button-label]');
      const status = root.querySelector('[data-srp-form-status]');
      const confirmation = root.querySelector('[data-srp-cart-confirmation]');
      if (!form || !button || !buttonLabel || !status || !confirmation) return;

      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        status.textContent = '';
        confirmation.hidden = true;

        try {
          const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: new FormData(form)
          });

          const result = await response.json();
          if (!response.ok) throw new Error(result.description || status.dataset.errorMessage);

          confirmation.hidden = false;

          const cartResponse = await fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
            headers: { Accept: 'application/json' }
          });
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            const cartButton = document.querySelector('.srs-header__cart');
            if (cartButton) {
              let count = cartButton.querySelector('.srs-header__cart-count');
              if (!count) {
                count = document.createElement('span');
                count.className = 'srs-header__cart-count';
                count.setAttribute('aria-hidden', 'true');
                cartButton.appendChild(count);
              }
              count.textContent = String(cart.item_count);
              const currentLabel = cartButton.getAttribute('aria-label') || 'Cart';
              const baseLabel = currentLabel.split(':')[0];
              cartButton.setAttribute('aria-label', `${baseLabel}: ${cart.item_count}`);
            }
          }
        } catch (error) {
          status.textContent = error.message || status.dataset.errorMessage;
        } finally {
          button.disabled = false;
          button.removeAttribute('aria-busy');
        }
      });
    };

    document.querySelectorAll('[data-srp-root]').forEach(initialiseProduct);
    document.addEventListener('shopify:section:load', (event) => {
      initialiseProduct(event.target.querySelector('[data-srp-root]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
  
  
  
  
  class CartNote extends HTMLElement {
    constructor() {
      super();

      this.addEventListener('change', debounce((event) => {
        const body = JSON.stringify({ note: event.target.value });
        fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
      }, 300))
    }
  }
  customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;

            const recommendations = html.querySelector('[grid-recommendation]');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.querySelector('[grid-recommendation]').innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
